module.exports = __webpack_public_path__ + "static/Sell_HeaderBG-a3d340ec3ceb975d9203f2a84b0fae8d.jpg";